import { AuthenticationService } from "../../legacy/services/authentication-service/authentication.service";
import { ApiClientFactory } from "./api-client.factory";
import type { IApiClientFactory } from "./api-client.factory.interface";

class ApiClientProvider {
  private _factory: IApiClientFactory | null = null;

  public getFactory(): IApiClientFactory {
    if (!this._factory) {
      this._factory = new ApiClientFactory(undefined, new AuthenticationService());
    }
    return this._factory;
  }

  public setFactory(factory: IApiClientFactory): void {
    this._factory = factory;
  }

  public resetFactory(): void {
    this._factory = null;
  }
}

export const apiClientProvider = new ApiClientProvider();
